<template>
  <section>
    <template v-for="(list, idx) in formData[fieldName]">
      <div class="universal-ticket-block" :key="`${fieldName}Utilize_${idx}`" v-show="!list.toBeDelete" :ref="`items${idx}`">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <!-- 名前 -->
          <el-col :span="4">
            <el-form-item :label="$locale('global.name')" :prop="`${fieldName}[${idx}].name`" :rules="mandatoryField">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.1')"
                v-model="list.name"
                maxlength="100"
                :disabled="fieldsDisabled.name"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 取引先 -->
          <el-col :span="3" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-form-item :label="$locale('accountReceivable.client')" :prop="`${fieldName}[${idx}].clientId`">
              <!-- <el-select
                :placeholder="$locale('movie.ticketList.ph.2')"
                v-model="list.clientId"
                :disabled="fieldsDisabled.clientId"
                :filterable="true"
                :clearable="true"
              >
                <el-option
                  v-for="option in distributorOptions"
                  :label="option.name"
                  :value="option.id"
                  :key="`${fieldName}${idx}_distributor_${option.id}`"
                ></el-option>
              </el-select> -->
              <!-- <remote-select
                type="client"
                :isMultiple="false"
                v-model="list.clientId"
                :formValue.sync="list.clientId"
                :actionType="$route.path.indexOf('create') > -1 ? 'create' : 'edit'"
              ></remote-select> -->
              <RemoteSelectV2
                ref="selectV2Client"
                type="client"
                :list="comClientList"
                v-model="list.clientId"
                :isMultiple="false"
                :formValue.sync="list.clientId"
                :fields="['id', 'name']"
                @setList="arr => comClientList = arr"
              />
            </el-form-item>
          </el-col>

          <!-- 表示順（昇順） -->
          <el-col :span="2" v-if="authority.isOtherType">
            <el-form-item :label="$locale('couponLib.displayOrder_asce')" :prop="`${fieldName}[${idx}].sort`">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.3')"
                v-model.number="list.sort"
                :disabled="fieldsDisabled.sort"
                maxlength="5"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 興行収入計上金額 -->
          <el-col :span="4">
            <el-form-item :label="$locale('couponLib.amountOfBoxOfficeRevenue')" :prop="`${fieldName}[${idx}].boxOfficeAmount`" :rules="mandatoryField">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.3')"
                v-model="list.boxOfficeAmount"
                maxlength="20"
                @change="evt => currencyFieldHandle({ value: evt, idx, type: 'boxOfficeAmount' })"
                :disabled="fieldsDisabled.boxOfficeAmount"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 販売金額 -->
          <el-col :span="3" v-if="!authority.isOtherType">
            <el-form-item :label="$locale('movie.ticketMaster.sellAmount')" :prop="`${fieldName}[${idx}].sellAmount`">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.4')"
                v-model="list.sellAmount"
                maxlength="20"
                @change="evt => currencyFieldHandle({ value: evt, idx, type: 'sellAmount' })"
                :disabled="fieldsDisabled.sellAmount"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- チケット印字金額 -->
          <el-col :span="3" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-form-item :label="$locale('couponLib.ticketPrintAmount')" :prop="`${fieldName}[${idx}].actualAmount`">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.5')"
                v-model="list.actualAmount"
                maxlength="20"
                @change="evt => currencyFieldHandle({ value: evt, idx, type: 'actualAmount' })"
                :disabled="fieldsDisabled.actualAmount"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 手数料 -->
          <el-col :span="4" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-row :gutter="10">
              <el-form-item :label="$locale('global.fee')">
                <el-col :span="12">
                  <el-form-item :prop="`${fieldName}[${idx}].feeCircle`">
                    <el-input
                      :placeholder="$locale('movie.ticketList.ph.6')"
                      v-model.number="list.feeCircle"
                      maxlength="20"
                      :disabled="fieldsDisabled.feeCircle"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :prop="`${fieldName}[${idx}].feeCircleType`">
                    <el-select
                      v-model="list.feeCircleType"
                      :disabled="fieldsDisabled.feeCircleType"
                    >
                      <el-option
                        v-for="option in currencyList"
                        :label="option.label"
                        :value="option.value"
                        :key="`${fieldName}${idx}_currencyList_${option.value}`"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <!-- メガネ代 -->
          <el-col :span="3" v-if="!authority.isOtherType">
            <el-form-item :label="$locale('movie.ticketMaster.glassesFee')" :prop="`${fieldName}[${idx}].glassesAmount`" :rules="mandatoryField">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.5')"
                v-model="list.glassesAmount"
                maxlength="20"
                :disabled="fieldsDisabled.glassesAmount"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 券種コード -->
          <el-col :span="2">
            <el-form-item :label="$locale('movie.codeOfMulberry')" :prop="`${fieldName}[${idx}].ticketingCode`">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.7')"
                v-model="list.ticketingCode"
                maxlength="2"
                :disabled="fieldsDisabled.ticketingCode"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 利用人数 -->
          <el-col :span="2">
            <el-form-item :label="$locale('movie.numOfUsers')" :prop="`${fieldName}[${idx}].useNumber`">
              <el-input
                :placeholder="$locale('movie.ticketList.ph.8')"
                v-model.number="list.useNumber"
                maxlength="1"
                :disabled="fieldsDisabled.useNumber"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- 専用券（スクリーン規格） -->
          <el-col :span="4" v-if="authority.type !== adminTypeList.SUP_AMIN">
            <el-form-item :label="$locale('movie.specialTicket')" :prop="`${fieldName}[${idx}].usableVersion1`" :rules="mandatoryField">
              <el-select v-model="list.usableVersion1" :disabled="fieldsDisabled.usableVersion1">
                <el-option
                  v-for="option in versionList"
                  :label="option.name"
                  :value="option.id"
                  :key="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="3" v-if="authority.type === adminTypeList.SUP_AMIN || authority.isOtherType">
            <el-form-item prop="">
              <CtrlBtns
                :fieldData="formData[fieldName]"
                :index="idx"
                :authority="authority"
                :newestIsOnTop="true"
                :factDispList="factDispList"
                @clickAction="operation => ticketListingCtrl({ operation, idx })"
              ></CtrlBtns>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="alertMsg-block" v-if="authority.type !== adminTypeList.SUP_AMIN">
          <el-col>
            <el-form-item :label="$locale('rules.alertMessage')">
              <el-row :gutter="10" v-for="(msg, msgIdx) in list.checkMessages" :key="`${fieldName}${idx}_alertMsg${msgIdx}`">
                <el-col :span="4">
                  <el-form-item
                    :prop="`${fieldName}[${idx}].checkMessages[${msgIdx}].deviceType`"
                    :rules="[{
                      required: msg.checkMsg !== '',
                      message: $locale('form.mandatoryField'),
                      trigger: 'change',
                    }]"
                  >
                    <el-select v-model="msg.deviceType" :disabled="fieldsDisabled.checkMessages" clearable>
                      <el-option
                        v-for="option in deviceList"
                        :label="option.label"
                        :value="option.value"
                        :key="`${fieldName}${idx}_deviceList_${option.value}`"
                        :disabled="isPlatformDisabled(option.value, msgIdx, idx)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :prop="`${fieldName}[${idx}].checkMessages[${msgIdx}].checkMsg`">
                    <el-input
                      :placeholder="$locale('form.plsEnterMsg')"
                      v-model="msg.checkMsg"
                      :disabled="fieldsDisabled.checkMessages"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <CtrlBtns
                    :fieldData="formData[fieldName][idx].checkMessages"
                    :index="msgIdx"
                    :authority="{
                      ...authority.checkMessagesAuth,
                      add: authority.checkMessagesAuth.add && list.checkMessages.length < deviceList.length
                    }"
                    @clickAction="operation => ticketListingCtrl({ operation, idx, isSubArray: true, msgIdx })"
                  ></CtrlBtns>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="authority.type !== adminTypeList.SUP_AMIN">
          <el-col>
            <el-form-item :label="$locale('movie.coordination')" :prop="`${fieldName}[${idx}].mobilize`" class="w120">
              <BoolSelect :value.sync="list.mobilize" :disabled="fieldsDisabled.mobilize"></BoolSelect>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </template>

  </section>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { toThousands, adminTypeList } from "@/utils/common";
import  {
  mandatoryField,
  optionalField,
  ticketUtilizeObj,
  ticketCoordinationObj,
  currencyList,
  deviceList,
} from "@/assets/js/movieStatic";
import CtrlBtns from "./CtrlBtns";
import BoolSelect from "./BoolSelect.vue";
import RemoteSelect from "@/components/common/RemoteSelect";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";

export default {
  name: "common-ticket",
  inject: [ "clientList" ],
  components: {
    CtrlBtns,
    BoolSelect,
    RemoteSelect,
    RemoteSelectV2
  },
  props: {
    formData: {
      required: true,
      type: Object,
    },
    fieldName: {
      required: true,
      type: String,
    },
    distributorOptions: {
      required: true,
      type: Array,
    },
    versionList: {
      required: true,
      type: Array,
    },
    authority: {
      type: Object,
      default: () => ({
        type: null,
        edit: false,
        add: false,
        del: false,
        editFields: [],
      }),
    },
  },
  data() {
    return {
      optionalField,
      mandatoryField,
      currencyList,
      deviceList,
      adminTypeList,
      comClientList: [],
    };
  },
  mounted() {
    this.comClientList = this.injectClientList;
  },
  computed: {
    injectClientList() {
      return this.clientList();
    },
    fieldsDisabled() {
      let resultObj = {};

      Object.keys(tranfResData(ticketUtilizeObj)).forEach(key => {
        resultObj[key] = !this.authority.editFields.includes(key);
      });

      return resultObj;
    },
    factDispList() {
      return this.formData[this.fieldName].filter(_list => !_list.toBeDelete);
    },
  },
  methods: {
    isPlatformDisabled(platformValue, currentMsgIdx, currentTicketIdx) {
      const row = this.formData[this.fieldName][currentTicketIdx] || {};
      const messages = row.checkMessages || [];
      return messages.some((msg, idx) => idx !== currentMsgIdx && msg.deviceType === platformValue);
    },
    ticketListingCtrl({
      idx = 0, // main array index
      msgIdx = 0, // sub array index
      operation, // "ADD" | "DEL"
      isSubArray, // true | false
    }) {
      const _op = operation ? operation.toUpperCase() : null;
      if (!_op) {
        // eslint-disable-next-line no-console
        console.warn("[ticketListingCtrl]: 'operation' should be one of \"ADD\" | \"DEL\" ");
        return;
      } else if (
        (_op === "DEL" && typeof idx === undefined) ||
        (_op === "DEL" && isSubArray && (typeof idx === undefined || typeof msgIdx === undefined))
      ) {
        // eslint-disable-next-line no-console
        console.warn("[ticketListingCtrl]: 'index' is mandatory while delete some item in array");
        return;
      }

      let targetArray = isSubArray ? this.formData[this.fieldName][idx].checkMessages : this.formData[this.fieldName];
      let newArray = isSubArray ? tranfResData(ticketCoordinationObj) : tranfResData(ticketUtilizeObj);
      let targetIdx = isSubArray ? msgIdx : idx;

      if (_op === "ADD") {
        if (isSubArray && targetArray.length >= this.deviceList.length) { return; }
        if (this.$listeners.addItem) {
          this.$emit("addItem", idx);
        }
        if (isSubArray || this.authority.isOtherType) {
          targetArray.push({ ...newArray });
        } else {
          targetArray.unshift({ ...newArray });
        }
      } else if (_op === "DEL") {
        if (isSubArray) {
          targetArray.splice(targetIdx, 1);
        } else if (this.$listeners.delItem) {
          this.$emit("delItem", idx);
        }
      }
    },
    currencyFieldHandle({
      value,
      idx,
      type,
    }) {
      this.formData[this.fieldName][idx][type] = toThousands(parseInt(value.replace(/,/g, "")));
    },
  },
  watch: {
    formData(obj) {
      if (obj.otherNationalTicket.length > 0) {
        let _clientIds = obj.otherNationalTicket.map(item => item.clientId);
        if (_clientIds.length > 0) {
          getClientListService({
            ids: _clientIds,
            page: 0,
            pageSize: 9999,
            field: ["id", "name"]
          }).then(res => {
            if (res.data && res.data.data.length > 0) {
              this.comClientList = this.$_.uniqBy(res.data.data.concat(this.injectClientList), "id");
            }
          });
        }
      } else {
        this.comClientList = this.injectClientList;
      }
    }
  }
};
</script>

<style scoped lang="less">
  .universal-ticket-block {
    margin-bottom: 20px;
    padding: 20px 20px 0;
    background-color: @light-grey-bg;

    > .el-row {
      flex-wrap: wrap;

      .el-col {
        +.el-col-2 {
          min-width: 140px;
        }
        +.el-col-3 {
          min-width: 180px;
        }
        +.el-col-4 {
          min-width: 240px;
        }
      }
    }

    .alertMsg-block {
      .el-row + .el-row {
        margin-top: 20px;
      }
    }
  }
</style>